import { useEffect, useState } from "react";
import { allPortalHosts, portalListeners } from "./constants.mjs";
import { createPortal } from "react-dom";
const GorhomPortalItem = props => {
  if (!props.hostName) throw new Error("No name");
  const cur = allPortalHosts.get(props.hostName),
    [node, setNode] = useState(cur);
  return cur && node !== cur && setNode(cur), useEffect(() => {
    if (!props.hostName || node) return;
    const listener = node2 => {
      setNode(node2);
    };
    return portalListeners[props.hostName] ||= /* @__PURE__ */new Set(), portalListeners[props.hostName].add(listener), () => {
      portalListeners[props.hostName]?.delete(listener);
    };
  }, [node]), node ? createPortal(props.children, node) : null;
};
export { GorhomPortalItem };
//# sourceMappingURL=GorhomPortalItem.mjs.map
